import _asyncToGenerator from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "regenerator-runtime/runtime.js";
import { convertToEnglishDigit } from "../../helpers/Functions";
import ApiService from "./ApiService";

var AuthApiService = /*#__PURE__*/function (_ApiService) {
  _inherits(AuthApiService, _ApiService);

  var _super = _createSuper(AuthApiService);

  function AuthApiService() {
    _classCallCheck(this, AuthApiService);

    return _super.apply(this, arguments);
  }

  _createClass(AuthApiService, [{
    key: "login",
    value:
    /**
     *
     * @param {string} phone
     * @returns {Promise}
     */
    function () {
      var _login = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(phone) {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.axios.post("auth/login", {
                  phone: convertToEnglishDigit(phone)
                });

              case 3:
                res = _context.sent;
                return _context.abrupt("return", res);

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", this.throwFetchError(_context.t0));

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function login(_x) {
        return _login.apply(this, arguments);
      }

      return login;
    }()
    /**
     *
     * @param {string} phone
     * @param {string} code
     * @returns {Promise}
     */

  }, {
    key: "verify",
    value: function () {
      var _verify = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(phone, code) {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.axios.post("auth/verify", {
                  phone: convertToEnglishDigit(phone),
                  code: convertToEnglishDigit(code)
                });

              case 3:
                res = _context2.sent;
                return _context2.abrupt("return", res);

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", this.throwFetchError(_context2.t0));

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));

      function verify(_x2, _x3) {
        return _verify.apply(this, arguments);
      }

      return verify;
    }()
    /**
     *
     * @returns {Promise}
     */

  }, {
    key: "logout",
    value: function () {
      var _logout = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var fcmToken, res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                fcmToken = localStorage.getItem("notification-token");
                _context3.prev = 1;
                _context3.next = 4;
                return this.axios.post("auth/logout", {
                  fcmToken: fcmToken
                });

              case 4:
                res = _context3.sent;
                return _context3.abrupt("return", res);

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](1);
                return _context3.abrupt("return", this.throwFetchError(_context3.t0));

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1, 8]]);
      }));

      function logout() {
        return _logout.apply(this, arguments);
      }

      return logout;
    }()
  }]);

  return AuthApiService;
}(ApiService);

var authApiService = new AuthApiService();
export default authApiService;